(() => {
  'use strict';
  document.addEventListener('click', event => {
    document.querySelectorAll('.ffp-country-selector[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ffp-country-selector[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  const source = document.getElementById('ffp-widget-translations');
  if (!source) return;
  let entries;
  try { entries = JSON.parse(source.textContent); } catch { return; }
  const extra = document.getElementById('ffp-cro-translations');
  if (extra) { try { Object.assign(entries, JSON.parse(extra.textContent)); } catch {} }
  const normalize = value => value.trim().replace(/\s+/g, ' ').toLowerCase();
  const dictionary = new Map(Object.entries(entries).map(([key, value]) => [normalize(key), value]));
  const excluded = 'script,style,noscript,textarea,input,[contenteditable="true"],.ffp-country-selector';
  const translate = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!node.parentElement || node.parentElement.closest(excluded)) return;
      const value = dictionary.get(normalize(node.nodeValue));
      if (value && value !== node.nodeValue.trim()) node.nodeValue = node.nodeValue.replace(/\S[\s\S]*\S|\S/, value);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE || node.closest(excluded)) return;
    ['aria-label','title'].forEach(attribute => {
      const original = node.getAttribute(attribute);
      const value = original && dictionary.get(normalize(original));
      if (value && value !== original) node.setAttribute(attribute, value);
    });
    Array.from(node.childNodes).forEach(translate);
  };
  translate(document.body);
  const pending = new Set();
  let frame = 0;
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(node => pending.add(node));
      else pending.add(record.target);
    });
    if (!frame && pending.size) frame = requestAnimationFrame(() => {
      frame = 0;
      const nodes = Array.from(pending);
      pending.clear();
      nodes.forEach(node => { if (node.isConnected) translate(node); });
    });
  });
  observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','title']});
})();
